var render = function render(){var _vm=this,_c=_vm._self._c;return _c('textarea',_vm._g(_vm._b({staticClass:"form-input",class:{ 'show-on-ready': _vm.showOnReady, ready: _vm.ready }},'textarea',_vm.$props,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }